import { Component, OnInit } from '@angular/core';
import { InternalMsgService } from '../services/internal.msg.service';
import { AccountService } from '../services/account.service';
import { Subscription } from 'rxjs';
import { AccountItem } from '../models/accountitem';
import { Router } from '@angular/router';

@Component({
    selector: 'app-access-denied',
    template: `<div class="full-height content-centered inline">
            <h1 *ngIf="showMessage" class="headline">Åtkomst nekad/Access denied</h1>
            <p class="headline">Du har inte tillräcklig behörighet för att se begärt innehåll.</p>
            <p class="headline">-----------------------------------------------------------------</p>
            <p class="headline">You don\'t have sufficient access rights for the requested content</p>
            </div>`
})
export class AccessDeniedComponent implements OnInit {
    msgSubscr: Subscription = new Subscription;
    loggedAccount: AccountItem = new AccountItem;
    showMessage: boolean = false;
    constructor(private msgService: InternalMsgService,
        private accountService: AccountService, 
        private router: Router) { 
        //
    }

    ngOnInit(): void {
        this.msgSubscr = this.msgService.loggedInAccountSet$.subscribe( 
            account => {
                this.loggedAccount = account;
                if (!this.loggedAccount?.isSystemAilable) {
                    this.router.navigate( ['systemunavail'] );
                } else {
                    this.showMessage = true;
                }
        } ); 

        this.accountService.fetchAccount();
    }

}
